export default __webpack_public_path__ + "static/media/fire-resistance.9bcbeeb5.svg";